import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.user.roles');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type UserRole = 'admin' | 'manager' | 'user';

interface IUserRoleRow {
    id: string;
    name: string;
    email?: string;
    department?: string;
    role: UserRole;
    created?: string;
    last_access?: string;
}

@Component({
    selector: 'wiz-page-user-roles',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.user.roles/view.scss */
/* src/app/page.user.roles/view.scss: no such file or directory */`],
})
export class PageUserRolesComponent implements OnInit {
    public users: IUserRoleRow[] = [];
    public loading: boolean = false;
    public savingId: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public get managerCount(): number {
        return this.users.filter((user) => user.role === 'manager').length;
    }

    public get userCount(): number {
        return this.users.filter((user) => user.role === 'user').length;
    }

    public async ngOnInit() {
        await this.service.init(this);
        if (!this.service.auth.allow('admin', '/main')) {
            await this.service.loading.hide();
            return;
        }

        await this.load();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async load() {
        this.loading = true;
        this.ref.detectChanges();

        const { code, data } = await wiz.call('list');
        this.loading = false;

        if (code === 200) {
            this.users = data.users || [];
        } else {
            await this.service.alert.show({
                title: '접근 불가',
                message: data || '사용자 목록을 불러올 수 없습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            this.service.href('/main');
        }

        this.ref.detectChanges();
    }

    public canToggle(user: IUserRoleRow): boolean {
        return user.role === 'user' || user.role === 'manager';
    }

    public getRoleLabel(role: string): string {
        const labels: any = {
            admin: '관리자',
            manager: '매니저',
            user: '일반 사용자'
        };
        return labels[role] || role || '-';
    }

    public getRoleClass(role: string): string {
        const classes: any = {
            admin: 'bg-purple-50 text-purple-600',
            manager: 'bg-blue-50 text-blue-600',
            user: 'bg-slate-100 text-slate-500'
        };
        return classes[role] || 'bg-slate-100 text-slate-500';
    }

    public getToggleLabel(role: string): string {
        return role === 'manager' ? '일반 사용자로 변경' : '매니저로 변경';
    }

    public async toggleRole(user: IUserRoleRow) {
        if (!this.canToggle(user) || this.savingId) return;

        const nextRole = user.role === 'manager' ? 'user' : 'manager';
        const confirmed = await this.service.alert.show({
            title: '권한 변경',
            message: `${user.name || user.id}님의 권한을 ${this.getRoleLabel(nextRole)}(으)로 변경하시겠습니까?`,
            status: 'warning',
            action: '변경',
            cancel: '취소'
        });
        if (!confirmed) return;

        this.savingId = user.id;
        this.ref.detectChanges();

        const { code, data } = await wiz.call('toggle_role', { id: user.id });
        this.savingId = '';

        if (code === 200) {
            const updated = data.user;
            this.users = this.users.map((item) => item.id === updated.id ? updated : item);
            await this.service.alert.show({
                title: '변경 완료',
                message: data.message || '권한이 변경되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
        } else {
            await this.service.alert.show({
                title: '변경 실패',
                message: data || '권한 변경에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }

        this.ref.detectChanges();
    }
}

export default PageUserRolesComponent;